import { ActionConstants } from "../constants";

const initialState = {
  invoiceList: [],
  invoiceData: null,
  totalCount: 0,
  loading: false,
  status: "success",
  text: "",
  showSnackbar: false,
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionConstants.CREATE_INVOICE_SUCCESS:
      return {
        ...state,
        showSnackbar: false,
      };
    case ActionConstants.INVOICE_GET_ALL_SUCCESS:
      return {
        ...state,
        loading: false,
        invoiceList: action.payload.invoiceList,
        totalCount: action.payload.totalCount,
      };
    case ActionConstants.INVOICE_GET_BY_ID:
      return {
        ...state,
        loading: false,
      };
    case ActionConstants.INVOICE_GET_BY_ID_SUCCESS:
      return {
        ...state,
        invoiceData: action.payload.invoice,
      };
    case ActionConstants.CLEAR_INVOICE_DATA:
      return {
        ...state,
        invoiceData: null,
      };
    default:
      return state || {};
  }
};

export default invoiceReducer;
